import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
function AtlasAccordionHeader({ titleTextProps, subtitleText, children, }) {
    const { tokens: { component: { accordion }, semantic, }, } = useTheme();
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: accordion.summary.gap,
        } }, { children: [_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: titleTextProps.variant || "body1", fontWeight: semantic.fontWeight.emphasis.value }, { children: titleTextProps.text })), subtitleText && (_jsx(Typography, Object.assign({ variant: "h6", sx: Object.assign({}, applyTokens(accordion.subtitle)) }, { children: subtitleText })))] }), children && (_jsx(Box, Object.assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: accordion.summary.gap.value,
                } }, { children: children })))] })));
}
export const AccordionPresets = () => {
    return {
        components: {
            Header: AtlasAccordionHeader,
        },
    };
};
//# sourceMappingURL=accordion.js.map